module.exports = __webpack_public_path__ + "img/2000otherpages.6170f995.jpg";